import React from "react";
import { StandardTooltip } from "../../../../shared/StandardTooltip/StandardTooltip";

// ═══════════════════════════════════════════════════════════════════════════
// The plan screen's quiet building blocks (redesign 27 Oct, `opc-pv-*`):
// a bordered card with title + grey count + info tooltip, a clickable row
// with a grey chevron, and a thin progress bar.
// ═══════════════════════════════════════════════════════════════════════════

export const OpcCard = ({
  title,
  count,
  tip,
  aside,
  children,
  className = "",
}) => (
  <section className={`opc-pv-card ${className}`}>
    <header className="opc-pv-card__head">
      <span className="fw-bold dark-grey">{title}</span>
      {count != null ? <span className="opc-pv-count">{count}</span> : null}
      {tip ? (
        <StandardTooltip tooltTipContent={tip}>
          <img
            src="/assets/images/info-light.svg"
            alt=""
            className="cursor-pointer"
          />
        </StandardTooltip>
      ) : null}
      {aside ? (
        <span className="ms-auto d-flex align-items-center gap-2">{aside}</span>
      ) : null}
    </header>
    {children}
  </section>
);

export const OpcBar = ({ value = 0 }) => (
  <span className="opc-pv-bar" aria-label={`${value}%`}>
    <span className="opc-pv-bar__track">
      <i style={{ width: `${value}%` }} />
    </span>
    <span className="opc-pv-bar__pct">{value}%</span>
  </span>
);

export const OpcRow = ({ onClick, children }) => (
  <div
    className="opc-pv-row"
    role="button"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={(e) => e.key === "Enter" && onClick()}
  >
    {children}
    <img
      src="/assets/images/right-arrow-gray.svg"
      alt=""
      className="opc-pv-row__chev"
    />
  </div>
);

export default OpcCard;
